import antdEnUS from 'ant-design-vue/es/locale-provider/en_US'
import momentEN from 'moment/locale/en-gb'
import setting from './en-US/setting'

const components = {
  antLocale: antdEnUS,
  momentName: 'en',
  momentLocale: momentEN
}

export default {
  'message': '-',

  ...components,
  ...setting
}
